import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BumpIcon from '../public/static/images/item/promotion.svg';
import VipIcon from '../public/static/images/item/vip.svg';
import FeatureIcon from '../public/static/images/item/feature.svg';
import { selectSuccessPromotionModalViewState } from '../store/selectors';
import { PromotionServiceId } from '../components/types/promotion';
import { CurrentItemQuery } from '../graphql/graphql';

export const useSuccessPromotionAlertModal = () => {
  const { t } = useTranslation();
  const { isVisible: isOpenSuccessAlertModal, name } = useSelector(
    selectSuccessPromotionModalViewState
  );
  const onAcceptSuccessPaymentModalTerms = () => {
    window.location.reload();
  };

  const getSuccessAlertModalData = (item?: CurrentItemQuery['item']) => {
    const leaseTranslation = item?.leased
      ? t('pages.current_item.lease_type.lease')
      : t('pages.current_item.lease_type.buy');

    const categoryTranslation = t(
      `pages.current_item.categories.id_${item?.category?.id}`
    );

    switch (name) {
      case PromotionServiceId.Bump:
        return {
          icon: BumpIcon,
          title: t('pages.current_item.alert_modal.bumped_success_title'),
          message: t('pages.current_item.promotion.raise_ad_info', {
            lease: leaseTranslation,
            category: categoryTranslation
          })
        };
      case PromotionServiceId.Vip:
        return {
          icon: VipIcon,
          title: t('pages.current_item.alert_modal.viped_success_title'),
          message: t('pages.current_item.promotion.make_vip_info', {
            lease: leaseTranslation,
            category: categoryTranslation
          })
        };
      case PromotionServiceId.Feature:
        return {
          icon: FeatureIcon,
          title: t('pages.current_item.alert_modal.featured_success_title'),
          message: t('pages.current_item.promotion.make_premium_info_alert')
        };
      case PromotionServiceId.Restore:
        return {
          icon: null,
          title: t('pages.current_item.alert_modal.restore_success_title'),
          message: t('pages.current_item.alert_modal.restore_success_message')
        };
      case PromotionServiceId.LimitPayment:
        return {
          icon: null,
          title: t('pages.current_item.alert_modal.awaiting_payment_title'),
          message: t('pages.current_item.alert_modal.awaiting_payment_message')
        };
      case PromotionServiceId.Deposit:
      case PromotionServiceId.Wallet:
      case PromotionServiceId.PayInvoice:
        return {
          icon: null,
          title: t('pages.profile.successful_pay_title'),
          message: t('pages.profile.successful_pay_description')
        };

      default:
        return {
          icon: null,
          title: '',
          message: ''
        };
    }
  };

  const successAlertModalData = getSuccessAlertModalData();

  const successAlertModalIcon = successAlertModalData.icon;
  const successAlertModalTitle = successAlertModalData.title;
  const successAlertModalMessage = (item: CurrentItemQuery['item']) =>
    getSuccessAlertModalData(item).message;

  return {
    isOpenSuccessAlertModal,
    onAcceptSuccessPaymentModalTerms,
    successAlertModalIcon,
    successAlertModalTitle,
    successAlertModalMessage
  };
};
